import { useMutation } from "@tanstack/react-query";

import { axiosInstance } from "../axios/axiosInstance";

export const key = ["archiveKey"];
export const useGetSearchedConversations = () =>
  useMutation(
    async (searchData) => {
      const { data } = await axiosInstance.get(
        `admin/messages/conversations?category=${searchData.category}&per_page=15&page=${searchData.page}&search=${searchData.searchString}`
      );
      return data;
    },
    {
      onSuccess: (data) => {
        console.log({ data });
      },
      onError: (error) => {
        console.log({ error });
      },
    }
  );
